import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { UseCases } from "@planzone/core";
import { useRemoveProjectExternalLink } from "@planzone/view-models";
import { useModal } from "@root/client/modal";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import { EditIcon } from "./editIcon";
import { BinIcon } from "./binIcon";
import styles from "./styles.scss";

function LinkMenu({ project, link }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const { removeProjectExternalLink } = useRemoveProjectExternalLink();

  return (
    <Safeguard
      useCases={[
        UseCases.addProjectExternalLink,
        UseCases.removeProjectExternalLink,
      ]}
    >
      {({ canAddProjectExternalLink, canRemoveProjectExternalLink }) => (
        <div className={styles.linkMenu}>
          {canAddProjectExternalLink && (
            <div
              className={styles.option}
              onClick={() =>
                pushView({
                  data: project,
                  key: UseCases.addProjectExternalLink,
                })
              }
            >
              <div className={styles.iconBox}>
                <EditIcon className={styles.icon} />
              </div>
              <p className={styles.text}>
                {t("projectPage.externalLinksList.edit")}
              </p>
            </div>
          )}
          {canRemoveProjectExternalLink && (
            <div
              className={classNames(styles.option, styles.remove)}
              onClick={() => removeProjectExternalLink({ project, link })}
            >
              <div className={styles.iconBox}>
                <BinIcon className={styles.icon} />
              </div>
              <p className={styles.text}>
                {t("projectPage.externalLinksList.remove")}
              </p>
            </div>
          )}
        </div>
      )}
    </Safeguard>
  );
}

export { LinkMenu };
